import script from "./moHistoryBack.vue?vue&type=script&setup=true&name=footer1_mo&lang=js"
export * from "./moHistoryBack.vue?vue&type=script&setup=true&name=footer1_mo&lang=js"

const __exports__ = script;

export default __exports__